import { AgResourceLanguage } from '../types';
import { sharePacks as EnUsSharePacks } from '../en-us/sharePacks';

export const sharePacks: AgResourceLanguage['sharePacks'] = {
  ...EnUsSharePacks,
  shippingFields: {
    ...EnUsSharePacks.shippingFields,
    title: 'Où envoyons-nous ce cadeau gratuit ?',
    subtitle:
      'Votre ami recevra ses sachets de voyage AG1 sous 3 à 5 jours ouvrables. Vous pourrez suivre la livraison dans votre historique de commande.',
    email: "E-mail de l'ami",
    giftMessage: 'Message cadeau (500 caractères maximum)',
    country: 'Pays/région',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    addressLine1: 'Adresse',
    addressLine2: 'Appartement, Suite, Etc (facultatif)',
    city: 'Ville',
    state: 'Province',
    zipCode: 'Code postal',
    phone: 'Téléphone',
    submitButtonText: 'Enregistrer',
    cancelButtonText: 'Annuler',
    label: 'Envoyer en tant que cadeau',
    caption: `
    <p>En passant cette commande, vous acceptez les 
      <a href="https://drinkag1.com/terms-and-conditions" target="_blank" rel="noopener">Conditions générales</a> 
      et&nbsp;<a href="https://drinkag1.com/privacy" target="_blank" rel="noopener">Politique de confidentialité</a>.
    </p>
  `
  },
  commonError: 'Un problème est survenu. Veuillez réessayer plus tard.',
  title: 'Partagez GRATUITEMENT des sachets de voyage AG1 avec vos amis :',
  subtitle:
    'Offrez-leur un aperçu de ce que cela fait de prendre soin de leur santé avec un pack de 5 — c’est pour nous.*',
  disclosure:
    '*Limité aux abonnés actifs. L’offre de sachets de voyage AG1 gratuits est valable pendant 30 jours après la notification. Les sachets de voyage AG1 gratuits ne sont pas transférables, doivent être échangés via le portail des membres et ne peuvent être expédiés qu’à des adresses aux États-Unis. Limite de trois sachets de voyage AG1 par client qualifié.',
  status: {
    shared: 'Vous avez partagé tous vos packs',
    expired:
      'Le programme pilote de partage de packs gratuits est terminé, revenez plus tard pour plus !',
    limited: 'Programme temporaire',
    expiring: "L'offre de sachets de voyage gratuits expire le {{date}}."
  },
  button: {
    ...EnUsSharePacks.button,
    share: 'Partagez 5 sachets de voyage',
    expired: 'Expiré',
    viewOrder: 'Voir la commande',
    shared: 'Partagé'
  },
  modal: {
    ...EnUsSharePacks.modal,
    head: 'Partagez des sachets de voyage gratuits',
    title: 'Où envoyons-nous ce cadeau gratuit ?',
    subtitle:
      'Votre ami recevra ses sachets de voyage AG1 sous 3 à 5 jours ouvrables. Vous pourrez suivre la livraison dans votre historique de commande.'
  },
  checkout: {
    ...EnUsSharePacks.checkout,
    success: 'Votre commande a été créée avec succès.'
  },
  subscriptionFreeGiftName: 'Partagez des packs gratuits',
  buttonTrack: 'Suivre la commande',
  freeGiftPrice: 'Gratuit',
  subscriptionNameLabel: 'Type de commande'
};
